<template>
  <div>
    <el-container>
      <el-header>
        <head_page :head_page_type=false ref="head_page"></head_page>
      </el-header>

      <el-main>
          <div id='choose_city' style="backgroundColor: white">
          <head_menu :has-back=true @go-back-click="goBack">
           <template #title>
              <div style="text-align:center;background-color: #F0F0EE;color:#53ADBC;padding:5px;font-size: 18px;">
              {{name}} - {{chosen_city}}
              </div>
            </template>
          </head_menu>
         
          <div>
                 <el-row  style="margin: 10px -10px 10px -10px; height: 100px;" :gutter="20">
                    <el-col :span="3">
                         <div style="background-color: #4DB6AC;padding:5px">
                           <p style="color:#4DB6AC;font-size:15px;visibility: hidden;">&nbsp;</p>
                          <div style="color:#FFFFFF;font-size:28px">{{num_proposal}}</div>
                           <div style="color:#FFFFFF;font-size:15px">{{$t('message.Statistic_proposal')}}</div>
                          </div>
                    </el-col>
                     <el-col :span="5">
                         <div style="padding:5px">
                          <p style="color:#4DB6AC;font-size:15px;visibility: hidden;">&nbsp;</p>
                          <div style="color:#4DB6AC;font-size:28px">{{intToString(pipeline)}} ¥</div>
                           <div style="color:#4DB6AC;font-size:15px">{{$t('message.Total_Pipeline')}}</div>
                          </div>
                    </el-col>
                     <el-col :span="4">
                         <div style="padding:5px">
                            <p style="color:#4DB6AC;font-size:15px;visibility: hidden;">&nbsp;</p>
                          <div style="color:#4DB6AC;font-size:28px">{{intToString(wins)}} ¥</div>
                           <div style="color:#4DB6AC;font-size:15px">{{$t('message.Wins')}} </div>
                          </div>
                    </el-col>
                    <el-col :span = "12">
                     <el-col :span="6">
                         <div style="padding:5px">
                            <p style="color:#4DB6AC;font-size:15px;visibility: hidden;">&nbsp;</p>
                          <div style="color:#4DB6AC;font-size:28px">
                           <div v-if="wins_trend >= 0" style="color:#4DB6AC;"><div style = "display :inline-block;width: 0;height: 0;border-bottom: 10px solid #4DB6AC;border-left: 10px solid transparent;border-right: 10px solid transparent;"></div> <div style = "display: inline-block;font-size: 20px;">{{wins_trend}}</div><div style="display:inline-block; font-size:14px"> %</div></div>
                          <div v-if="wins_trend < 0" style="color:red;"><div style = "display :inline-block;width: 0;height: 0;border-top: 10px solid red;border-left: 10px solid transparent;border-right: 10px solid transparent;"></div> <div style = "display: inline-block; font-size: 20px;">{{wins_trend}}</div> <div style="display:inline-block;font-size:14px"> %</div></div>
                          </div>
                           <div style="color:#4DB6AC;font-size:15px">{{$t('message.YOY_Trend')}} </div>
                          </div>
                    </el-col>
                    </el-col>
                 </el-row>
                 <el-row v-for="(item , index) in data_proposal" :key="index" :index="index" >
                      <el-row style="margin-top:15px;border-bottom:1px solid black;height:50px;">

                     
                      <el-col :span="4">
                         <div style="padding:4px">
                          <div style="font-size:22px;display:inline-block">{{item.month.substring(0,7)}}</div>
                            <div  :id ="'icon_up_'+index" style="display:inline-block;font-size:16px;margin-left:5px" v-show="false"  @click="showOrCacheTable1(index)"><i class="el-select__caret el-input__icon el-icon-arrow-up"></i></div>
                             <div :id ="'icon_down_'+index" style="display:inline-block;font-size:16px;margin-left:5px;"  @click="showOrCacheTable1(index)"> <i class="el-select__caret el-input__icon el-icon-arrow-down"></i></div>
                          </div>
                    </el-col>
                    <el-col :span="4">
                         <div style="padding:4px">
                          <div style="font-size:22px;display:inline-block">{{item.sum_cost == null? 0: intToString(item.sum_cost)}} ¥</div>
                           
                        
                          </div>
                    </el-col>
                    <el-col :span="4">
                        <div style="padding:4px">
                          <div style="font-size:22px;display:inline-block">{{item.wins == null? 0: intToString(item.wins)}} ¥</div>
                           
                        
                          </div>
                          
                    </el-col>
                     <el-col :span = "6">
                         <div style ="height:50px" :ref = "item.month" :id="'echart'+index"></div>
                    </el-col>
                    <el-col :span = "5">
                        <div style="font-size:22px;display:inline-block">{{$t('message.Avg_Discount')}}:  {{item.avg_discount}}%</div>
                           
                        
                        
                      

                    </el-col>
                     </el-row>
                       <el-row>
                      <el-table :id = "'table_'+index" :data="item.data"  :show-header=true
                       style="background-color: #f8f8f9; width:100%; font-size: 9px" >
                         
                         <el-table-column min-width="17%" align="center" style = "font-size:18px"  :label="$t('message.Date')">
                             <template slot-scope="scope">
                                {{scope.row.created_at}} 
                            </template>
                        </el-table-column>
                          <el-table-column min-width="15%" align="center" style = "font-size:18px" :label="$t('message.Total_Pipeline')">
                             <template slot-scope="scope">
                               {{intToString(scope.row.estimated_cost)}}  ¥
                            </template>
                        </el-table-column>
                        
                          <el-table-column min-width="18%" align="center" style = "font-size:18px" :label="$t('message.Wins')">
                             <template slot-scope="scope">
                                {{scope.row.proposal_status != 4? 0 :intToString(scope.row.estimated_cost)}}  ¥
                            </template>
                        </el-table-column>
                          <el-table-column min-width="20%" align="center" style = "font-size:18px"  :label="$t('message.Client') +'-'+ $t('message.City')">
                             <template slot-scope="scope">
                                 {{scope.row.client_name}} -  {{scope.row.city}}
                            </template>
                        </el-table-column>
                         <el-table-column min-width="10%" align="center" style = "font-size:18px" :label="$t('message.Whole_Cycle')">
                             <template slot-scope="scope">
                              {{scope.row.updated_at}} {{$t('message.Days')}}
                            </template>
                        </el-table-column>
                          <el-table-column min-width="20%" align="center" style = "font-size:18px"  :label="$t('message.Discount')">
                             <template slot-scope="scope">
                              {{scope.row.report_param}} %
                            </template>
                        </el-table-column>
                         
                        
                        
                         
                    </el-table>

                 </el-row>
                 </el-row>
                 

          </div>
          </div>
      </el-main>
    </el-container>
    </div>
    </template>
    <script>
import head_page from "./components/head_page.vue";
import head_menu from './components/head_menu.vue';
import _global from "./components/global.vue";
import parseUtil from './utils/parseUtils.vue';
import echarts from 'echarts';

export default {
    name: "statisticPerson",
    mixins: [parseUtil],
  data(){
    return {
        name:'',
        chosen_city:'',
        num_proposal:0,
        pipeline: 0,
        wins: 0,
        proposal_loading: false,
        proposal_month: [],
        pipeline_this_month: 0,
        win_this_month: 0,
        pipeline_last_month: 0,
        win_last_month: 0,
        proposal_last_month: [],
        pipeline_last_2_month: 0,
        win_last_2_month:0,
        proposal_last_2_month: [],
        pipeline_last_3_month: 0,
        win_last_3_month:0,
        proposal_last_3_month: [],
        this_month: 0,
        last_month:0,
        last_2_month: 0,
        wins_trend : 0,
        data_proposal:[],
        items:[{proposal:1000,win:200},{proposal:2000,win:100}],
        isShowThisMonth:true,
        page_reload : false,
        avg_discount: 100,
        isShowLastMonth:true,
        activerange: 'Year'
    }
  },
  components: {
    head_page,
    head_menu,


  },
 
//  async created(){
//     await this.test()
//  },
  watch: {
    "page_reload":{
      handler(new_value,old_value){
        if (new_value == true && old_value == false){
    
         this.drawChart()
        }
      }
    },
  
  },
  mounted(){
    this.$refs.head_page.update_user_name();
    this.name = this.$route.query.name
    this.chosen_city = this.$route.query.city
    let now = new Date()
    this.activerange = this.$route.query.day
    this.this_month =now.getFullYear() + '-'+(now.getMonth() +1)
    this.activerange = this.$route.query.day
    if(now.getMonth() == 1){
        this.last_month = (now.getFullYear()-1) + '-'+ 12
        this.last_2_month = (now.getFullYear()-1) + '-'+ 11
        
    } else if(now.getMonth()==2){
        this.last_month = now.getFullYear() + '-'+(now.getMonth())
        this.last_2_month = (now.getFullYear()-1) + '-'+ 12
    }
    else {
        this.last_month = now.getFullYear() + '-'+(now.getMonth())
        this.last_2_month = now.getFullYear() + '-'+(now.getMonth()-1)
    }
    this.getProposalIndividual()
    // this.test()
  },
  methods:{
    
     goBack() {
        this.$router.push({path:'/statistics',query:{chosen_city:this.chosen_city,day:this.$route.query.day}})
    //   this.$router.back();
    },
    showOrCacheTable1(index){
        if (this.data_proposal[index].isShowData == false) {
             document.getElementById("icon_down_"+index).style.display="initial"
             document.getElementById("icon_up_"+index).style.display="none"
             document.getElementById("table_"+index).style.display=""
            this.data_proposal[index].isShowData = true;
        } else {
            this.data_proposal[index].isShowData = false;
             document.getElementById("icon_up_"+index).style.display="initial"
             document.getElementById("icon_down_"+index).style.display="none"
              document.getElementById("table_"+index).style.display="none"
        }
        
    },
    drawChart(){
         this.data_proposal.forEach((e,i) => {
            let data_x = [];
            let data_y = [];
            e.data.forEach((value,index)=>{
                data_x.push(value.client_name)
                data_y.push(value.estimated_cost)
            })
           let chart_this_month = echarts.init(document.getElementById('echart'+i));
                chart_this_month.setOption({
                    grid: {
                        left: "0",
                        top: "0",
                        right: "0",
                        bottom: "5",
                        containLabel: true,
                        },
                    xAxis: {
                        type: 'category',
                        //不显示x轴线
                        show: true,
                        splitLine:{
                            show:false
                        },
                        axisLine:{
                            show:true
                        },
                        axisTick:{
                            show:false
                        },
                        axisLabel:{
    		                interval: 0,
                            formatter:function(value,index) {
                                return ''
                             }},
                        data:data_x
                        },
                        yAxis: {
                            type: 'value',
                            name:'total pipeline',
                            show: true,
                            splitLine:{
                                show:false
                            },
                            axisLine:{
                                show:false
                            },
                            axisTick:{
                                show:false
                            },
                            axisLabel: {
                                formatter: function(value,index) {
                                 if (value/ 1000000 >= 1) {
                                    value = (value/ 1000000).toFixed(1).replace(/[.]?0+$/g,"") + 'M'
                                } else if (value/ 1000 >= 1) {
                                    value = (value/ 1000).toFixed(1).replace(/[.]?0+$/g,"") + 'K'
                                }
                                return ''
                             },
                         }
                
                         },
                        tooltip : {
                            trigger: 'axis',
                            formatter:function(arg) {
              let result = "";

              let number = arg[0].data;
              number = number.toString();
              number = parseInt(number.replace(/,/g, ""));
              if (number < 1000) {
                result = number;
               } else if (number > 1000000000) {
                result =
                  (number / 1000000000).toFixed(1).toString().replace(".0", "") + "B";
              } else if (number > 1000000) {
                result =
                  (number / 1000000).toFixed(1).toString().replace(".0", "") + "M";
              } else {
                  result = (number / 1000).toFixed(1).toString().replace(".0", "") + "K";
              }
                    return  arg[0].axisValue+':<br/>'+result
                }
          
                        },
                        dataZoom:[
                                {
                                    show: false,
                                    type:'inside',
                                    startValue:0, // 从头开始。
                                    rangeMode: "value" ,
							        endValue:9 // 一次性展示4个
                                }
                        ],
                        series: [{
                            data: data_y,
                            barCategoryGap:'1',
              
                            type: 'bar',
                            itemStyle:{
                                normal:{
                                    color:function(params){
                    
                                        return '#4DB6AC'
                                    }
                                 }
                            }
             
                        }]
                })})
    },
     handle_draw_bar() {
        this.$nextTick(() => {
            this.page_reload = true;
       })},
    translateCity(city) {
        switch (city) {
            case 'Chengdu':
                return this.$t('message.Chengdu')
            case 'Shenzhen':
                return this.$t('message.Shenzhen')
            case 'Nanjing':
                return this.$t('message.Nanjing')
            case 'Chongqing':
                return this.$t('message.Chongqing')
            case 'Wuhan':
                return this.$t('message.Wuhan')
    }
    },
    getProposalIndividual(){
      let api_url = _global.serverSrc + "/statistic_individual_summary/" + "?chosen_city=" + this.chosen_city + "&date_range="+ this.activerange+"&name="+this.name;
       let obj = {'email': JSON.parse(sessionStorage.getItem('User'))}
      this.$axios
        .post(api_url, obj)
        .then((response) => {
          
            this.data_proposal = response.data.proposal
        
            
            
            for (var i = 0; i < response.data.proposal.length; i++) {
                
                   this.data_proposal[i].data = JSON.parse(response.data.proposal[i].data)
                   this.data_proposal[i].isShowData = true
                   
                   if(this.data_proposal[i].wins == null) {
                    this.data_proposal[i].wins = 0
                   }
                    let sum = 0;
                   
                    for (var index = 0; index < this.data_proposal[i].data.length; index++){
                       
                        sum +=this.data_proposal[i].data[index].report_param
                       
                    }
                    this.data_proposal[i].avg_discount = (sum/this.data_proposal[i].data.length).toFixed(2)
                }

             if (response.data.individual_summary) {
                this.num_proposal = response.data.individual_summary[0].number_proposal
                this.pipeline = response.data.individual_summary[0].sum_cost
                if(response.data.individual_summary[0].wins == null){
                    this.wins = 0
                } else {
                    this.wins = response.data.individual_summary[0].wins
                }
                 this.wins_trend = response.data.individual_summary[0].wins_trend
               
               
                 this.handle_draw_bar()

             

             }
        })
    }
  }
  }
</script>

